import { render, staticRenderFns } from "./TagInfo.vue?vue&type=template&id=18ce0264&scoped=true"
import script from "./TagInfo.vue?vue&type=script&lang=js"
export * from "./TagInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ce0264",
  null
  
)

export default component.exports